import { useThrottleFn } from '@vueuse/core';
import { ref, onUnmounted } from 'vue';

export const useScroll = () => {
  const scrollTop = ref(0);
  let lastScrollY = window.scrollY;
  let scrollTimer: ReturnType<typeof setTimeout> | null = null;
  let scrollInterval: ReturnType<typeof setInterval> | null = null;

  const handleScroll = useThrottleFn(() => {
    const currentScrollY = window.scrollY;
    // 判断是否为向下滚动
    const isScrollingDown = currentScrollY > lastScrollY;
    lastScrollY = currentScrollY;

    // 只有在向下滚动且在顶部区域时才自动滚动到60px位置
    // 因为向下滚动时，navbar会隐藏，而navbar的高度为64

    if (window.scrollY > 0 && window.scrollY < 20 && isScrollingDown) {
      window.scrollTo({
        top: 66,
        behavior: 'smooth', // 添加平滑滚动效果
      });
      scrollTop.value = 66;
      return;
    }
    scrollTop.value = window.scrollY;

    // 用户停止滚动一段时间后，添加定时器判断是否需要自动滚动
    if (scrollTimer) {
      clearTimeout(scrollTimer);
    }
    if (scrollInterval) {
      clearInterval(scrollInterval);
    }
    scrollTimer = setTimeout(() => {
      scrollInterval = setInterval(() => {
        if (window.scrollY === 0) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth', // 添加平滑滚动效果
          });
          scrollTop.value = 0;
        }
      }, 200);
    }, 150);
  }, 200); // 缩短节流时间以提高响应性

  window.addEventListener('scroll', handleScroll);

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
    if (scrollTimer) {
      clearTimeout(scrollTimer);
    }
    if (scrollInterval) {
      clearInterval(scrollInterval);
    }
  });

  return { scrollTop };
};
